export enum TipoPratica {
  Infortunio = 1,
  AttrezzaturaIncidentata = 2
}

export enum TipoPraticaStatistica {
  Infortunio = 1,
  EventoAccidentale = 2
}
